(function () {
  'use strict';
  angular
    .module('com.module.settings')
    .run(function ($rootScope, gettextCatalog) {
        
    });

})();
